import messages from './messages'

const i18nDateTimes = {}
const i18nLocales = Object.keys(messages)

for (const i in i18nLocales) {
    i18nDateTimes[i18nLocales[i]] = {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        },
        shortWithTime: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        },
        long: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            hour: 'numeric',
            minute: 'numeric',
        },
    }
}

export default i18nDateTimes
